import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import React from 'react'
import { CheckboxControl } from 'src/editor/shared/settings/checkbox-control'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import { MenuInterface } from 'src/shared/types/entities/menu'

export interface BurgerProps {
  isShowCheckbox?: boolean
  update: <K extends keyof MenuInterface>(
    prop: K,
  ) => (value: MenuInterface[K]) => void
  entity: MenuInterface
}

export const MenuBurger = ({
  update,
  entity,
  isShowCheckbox = true,
}: BurgerProps) => {
  const { isMobile } = useDeviceModeContext()

  if (!isMobile) {
    return null
  }

  return (
    <>
      {isShowCheckbox && (
        <CheckboxControl
          label="entity_settings.menu.item.show_burger_on_mobile"
          update={update('burger')}
          value={entity.burger}
        />
      )}
      {entity.burger && (
        <ColorPickerControl
          update={update('burgerIconColor')}
          color={entity.burgerIconColor}
          label="entity_settings.menu.item.burger_color"
          singleColorMode
        />
      )}
    </>
  )
}
